import React from 'react';
import { useAtomCallback, useAtomValue } from '@exodus/headless-ui';
import useTrackAssetConfigureEvent from '../../hooks/use-track-configure-asset.js';
import { fromAmountAtom, fromAssetAtom, fromWalletAccountAtom, prefillIdAtom, toAmountAtom, toAssetAtom, toWalletAccountAtom, isFlippableAtom, isLoadingAtom, } from '../../../atoms/index.js';
const FlipButton = ({ Component, className, style, onPress }) => {
    const isFlippable = useAtomValue(isFlippableAtom);
    const isLoading = useAtomValue(isLoadingAtom);
    const trackAssetConfigureSwap = useTrackAssetConfigureEvent();
    const handlePress = useAtomCallback(async (get, set) => {
        void trackAssetConfigureSwap();
        if (onPress)
            await onPress();
        const fromAsset = get(fromAssetAtom);
        const toAsset = get(toAssetAtom);
        const fromWalletAccount = get(fromWalletAccountAtom);
        const toWalletAccount = get(toWalletAccountAtom);
        set(fromAmountAtom, undefined);
        set(toAmountAtom, undefined);
        set(fromAssetAtom, toAsset);
        set(toAssetAtom, fromAsset);
        set(fromWalletAccountAtom, toWalletAccount);
        set(toWalletAccountAtom, fromWalletAccount);
        set(prefillIdAtom, null);
    }, [onPress, trackAssetConfigureSwap]);
    if (Component) {
        return (React.createElement(Component, { className: className, disabled: !isFlippable || isLoading, style: style, onPress: handlePress }));
    }
    return null;
};
export default FlipButton;
